import { MdsIconKind } from "@/design-system/components/icon";
import { MdsPanelResponsive } from "@/design-system/components/panel";
import {
  MDSButtonIcon,
  MDSButtonSlotName,
  MDSButton,
  MDSIconButton,
  MDSTooltip,
  MDSTooltipConfig,
  MDSButtonVariant,
} from "@/mds";

interface Props {
  fullSizeLabel: React.ReactNode;
  fullSizeIcon?: MdsIconKind;
  collapsedIcon: MdsIconKind;
  threshold: string;
  isDisabled?: boolean;
  onClick: () => void;
  tooltipConfig?: MDSTooltipConfig;
  collapsedTooltipConfig?: MDSTooltipConfig;
  variant?: MDSButtonVariant;
}

// This component is used to render a button that switches between a button and an icon button based on the container width

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export function MdsPanelResponsiveBtn({
  fullSizeLabel,
  fullSizeIcon,
  collapsedIcon,
  collapsedTooltipConfig,
  threshold,
  isDisabled,
  onClick,
  tooltipConfig,
  variant,
  ...rest
}: Props) {
  return (
    <>
      <MdsPanelResponsive minWidth={threshold} {...rest}>
        <MDSTooltip config={tooltipConfig}>
          <MDSButton onClick={onClick} isDisabled={isDisabled} variant={variant}>
            {fullSizeIcon && (
              <MDSButtonIcon slot={MDSButtonSlotName.LeftIcon} kind={fullSizeIcon} />
            )}
            {fullSizeLabel}
          </MDSButton>
        </MDSTooltip>
      </MdsPanelResponsive>
      <MdsPanelResponsive maxWidth={threshold}>
        <MDSTooltip config={collapsedTooltipConfig}>
          <MDSIconButton onClick={onClick} iconKind={collapsedIcon} isDisabled={isDisabled} />
        </MDSTooltip>
      </MdsPanelResponsive>
    </>
  );
}
